var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"bg-img",attrs:{"src":"https://iogw.cgo.ink:9000/hgzpub/pic/calendar/recopic2@3x.webp"}}),_c('div',{staticClass:"box"},[_c('div',{staticClass:"card-box"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"content-img",attrs:{"src":"https://iogw.cgo.ink:9000/hgzpub/pic/calendar/reco2@3x.webp"}})])])])])
}]

export { render, staticRenderFns }